import Vue from 'vue'
//自定义指令 
// v-dialogDrag: 弹窗拖拽
Vue.directive('dialogDrag', {
    bind(el) {//binding, vnode, oldVnode
        const dialogHeaderEl = el.querySelector('.el-dialog__header')
        const dragDom = el.querySelector('.el-dialog')
        dialogHeaderEl.style.cursor = 'move'

        // 获取原有属性 ie dom元素.currentStyle 火狐谷歌 window.getComputedStyle(dom元素, null);
        const sty = dragDom.currentStyle || window.getComputedStyle(dragDom, null)

        dialogHeaderEl.onmousedown = (e) => {
            // 鼠标按下，计算当前元素距离可视区的距离
            const disX = e.clientX - dialogHeaderEl.offsetLeft
            const disY = e.clientY - dialogHeaderEl.offsetTop

            // 获取到的值带px 正则匹配替换
            let styL, styT

            // 注意在ie中 第一次获取到的值为组件自带50% 移动之后赋值为px
            if (sty.left.includes('%')) {
                // eslint-disable-next-line no-useless-escape
                styL = +document.body.clientWidth * (+sty.left.replace(/\%/g, '') / 100)
                // eslint-disable-next-line no-useless-escape
                styT = +document.body.clientHeight * (+sty.top.replace(/\%/g, '') / 100)
            } else {
                styL = +sty.left.replace(/\px/g, '')
                styT = +sty.top.replace(/\px/g, '')
            }

            document.onmousemove = function (e) {
                // 通过事件委托，计算移动的距离
                const l = e.clientX - disX
                const t = e.clientY - disY

                // 移动当前元素
                dragDom.style.left = `${l + styL}px`
                dragDom.style.top = `${t + styT}px`

                // 将此时的位置传出去
                // binding.value({x:e.pageX,y:e.pageY})
            }

            document.onmouseup = function () {
                document.onmousemove = null
                document.onmouseup = null
            }
        }
    }
})
// v-editorHeight:编辑框拖大 拖小
Vue.directive('editorHeight', {
    bind(el) {
        el.onmousedown = (e) => {
            let ele = el.previousSibling.lastChild //上一个兄弟节点得最后一个子节点
            // let ele = el.parentNode.children[0].children[1]
            // let ele = el.parentNode.firstChild.lastChild

            let _height = ele.clientHeight
            // 鼠标按下，记录当前位置
            let oldY = e.clientY;

            document.onmousemove = function (e) {
                e.preventDefault() // 移动时禁用默认事件
                // 通过事件委托，计算移动的距离
                const l = e.clientY - oldY + _height
                if (l < 60) {
                    return
                }
                ele.style.height = `${l}px`
                ele.setAttribute('height', l);
            }

            document.onmouseup = function () {
                document.onmousemove = null
                document.onmouseup = null
            }
        }
    }
})

function onInput(el, ele, binding, vnode) {
    function handle() {

        let val = ele.value
        // modifiers为修饰符对象，传入了float，则其float属性为true
        // 清除"数字"和"."以及"-"以外的字符
        // eslint-disable-next-line no-useless-escape
        val = val.replace(/[^\-\d.]/g, '')
        // 只保留第一个'-'号
        // eslint-disable-next-line no-useless-escape
        val = val.replace(/\.{2,}/g, '.').replace(/\-{2,}/g, '-')
        // 将 '-.' 替换成 '-0.'
        // eslint-disable-next-line no-useless-escape
        val = val.replace(/^\./g, '0.').replace(/^\-\./, '-0.')
        if (typeof binding.value !== 'undefined') {
            // 期望保留的最大小数位数
            let pointKeep = 0
            if (typeof binding.value === 'string'
                || typeof binding.value === 'number') {
                pointKeep = parseInt(binding.value)
            } else if (typeof binding.value === 'object') {
                // 支持新的小数点保留位配置
                pointKeep = binding.value.decimal
            }
            if (!isNaN(pointKeep)) {
                if (!Number.isInteger(pointKeep)
                    || pointKeep < 0) {
                    pointKeep = 0
                }
                // 增加'-'号的支持
                // eslint-disable-next-line no-useless-escape
                const str = '^(\\-)*(\\d+)\\.(\\d\{' + pointKeep + '}).*$'
                const reg = new RegExp(str)
                if (pointKeep === 0) {
                    // 不需要小数点
                    val = val.replace(reg, '$1$2')
                } else {
                    // 通过正则保留小数点后指定的位数
                    val = val.replace(reg, '$1$2.$3')
                }
            }
        } else {
            val = ele.value.replace(/[^\d]/g, '')
        }
        if (val !== '' && typeof binding.value === 'object') {
            let { min, max } = binding.value
            min = parseFloat(min)
            max = parseFloat(max)
            if (!isNaN(min)) {
                if (min >= 0) {
                    // 不能是负数
                    val = val.replace('-', '')
                }
                if (parseFloat(val) < min) {
                    val = min
                }
            }
            if (!isNaN(max)) {
                if (parseFloat(val) > max) {
                    val = max
                }
            }
        }
        ele.value = val
        if (vnode.componentInstance) {
            vnode.componentInstance.$emit('input', ele.value)
        } else {
            vnode.elm.dispatchEvent(new CustomEvent('input', ele.value))
        }
    }
    return handle
}
const numberInput = {
    bind(el, binding, vnode) {
        const ele = el.tagName === 'INPUT' ? el : el.querySelector('input')
        ele.addEventListener('input', onInput(el, ele, binding, vnode), false)
    },
}
Vue.directive('number-input', numberInput)



